import React, { useEffect, useRef, useState } from 'react';
import {
  BestsellerContainer,
  CategoryGridContainer,
  ViewAllRow,
  ViewAllText,
} from './styled';
import AnchorCoverTag from '../../StoreHomePage/AnchorCoverTag';
import { useRouter } from 'next/router';
import { getSearchParams } from '../../Parenting/common';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import ProductContainer from './ProductContainer';

function CategoryProductFilter(props) {
  const {
    categoryData,
    setChangeCartCount,
    isForJoyfulPage,
    showNewProductVideoCardUx,
  } = props;
  const [cardEffect, setCardEffect] = useState();
  const router = useRouter();
  const [selectedCategory, setSelectedCategory] = useState(0);

  const categoryRefs = useRef([]);
  const isScrollingRef = useRef(false);

  const callbackFunction = (index, element) => {
    setCardEffect({ index: index, effect: 'lowOpacity' });
    setTimeout(() => {
      router.push(`${element}` + getSearchParams(), '', {
        locale: getRouterLocale(router),
      });
    }, [200]);
  };

  const [activeIndexes, setActiveIndexes] = useState({});

  const scrollRefs = useRef([]);
  const handleScroll = (i) => {
    const ref = scrollRefs.current[i];
    const numberOfDots = categoryData?.items?.[i]?.items?.length || 1;

    if (ref && numberOfDots > 1) {
      const scrollLeft = ref.scrollLeft;
      const totalScrollableWidth = ref.scrollWidth - ref.clientWidth;
      const sectionWidth = totalScrollableWidth / (numberOfDots - 1);

      let index = Math.round(scrollLeft / sectionWidth);
      index = Math.max(0, Math.min(index, numberOfDots - 1));

      setActiveIndexes((prev) => ({ ...prev, [i]: index }));
    }
  };

  const onClickCategory = (i) => {
    setSelectedCategory(i);
    isScrollingRef.current = true;
    const headerOffset = 200;
    const element = categoryRefs.current[i];
    if (element) {
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }

    setTimeout(() => {
      isScrollingRef.current = false;
    }, 1000);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (isScrollingRef.current) return;

      const headerOffset = 200;
      let currentCategory = 0;

      categoryRefs.current.forEach((section, index) => {
        if (section) {
          const rect = section.getBoundingClientRect();
          if (rect.top <= headerOffset + 10 && rect.bottom >= headerOffset) {
            currentCategory = index;
          }
        }
      });
      setSelectedCategory(currentCategory);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (categoryData?.items?.length) {
      const initialActiveIndexes = {};
      categoryData.items.forEach((_, index) => {
        initialActiveIndexes[index] = 0;
      });
      setActiveIndexes(initialActiveIndexes);
    }
  }, [categoryData]);

  return (
    <BestsellerContainer
      isForJoyfulPage={isForJoyfulPage}
      showNewProductVideoCardUx={showNewProductVideoCardUx}
    >
      <div className="elementContainer">
        {categoryData?.items?.map((item, i) => {
          return (
            <div key={`ele-${i}`}>
              <div
                onClick={() => onClickCategory(i)}
                className={`tabContainer ${
                  selectedCategory == i ? 'selected' : ''
                }`}
              >
                <img src={item?.icon} alt="" width={75} height={65}></img>
                <p>{item?.tabName}</p>
              </div>
              <div
                className={selectedCategory == i ? 'triangleDown' : ''}
              ></div>
            </div>
          );
        })}
      </div>

      {categoryData?.items?.map((ele, index) => {
        return (
          <CategoryGridContainer
            key={`element+index-${index}`}
            ref={(el) => (categoryRefs.current[index] = el)}
            sectionBgColor={ele?.sectionBgColor}
            showNewProductVideoCardUx={showNewProductVideoCardUx}
          >
            {showNewProductVideoCardUx ? (
              <>
                <ProductContainer
                  data={ele}
                  scrollRef={(el) => (scrollRefs.current[index] = el)}
                  onScroll={() => handleScroll(index)}
                  setChangeCartCount={setChangeCartCount}
                  isForJoyfulPage={isForJoyfulPage}
                  showNewProductVideoCardUx={showNewProductVideoCardUx}
                  hideSpecialPriceStrip={showNewProductVideoCardUx}
                />
                <ViewAllRow>
                  <div className="viewAllInnerWrapper">
                    <div className="dotsWrapper">
                      {ele?.items?.map((_, dotIndex) => (
                        <span
                          key={dotIndex}
                          style={{
                            height: 10,
                            width: 10,
                            margin: '0 5px',
                            borderRadius: '50%',
                            backgroundColor:
                              dotIndex === activeIndexes[index]
                                ? '#ef4e5e'
                                : '#ccc',
                            transition: 'all 0.3s ease',
                          }}
                        />
                      ))}
                    </div>

                    <AnchorCoverTag
                      url={ele?.webUrl}
                      cardEffect={cardEffect?.index === 0 ? 'lowOpacity' : ''}
                      callbackFunction={() =>
                        callbackFunction(
                          0,
                          categoryData?.items?.[selectedCategory]?.webUrl,
                        )
                      }
                    >
                      <ViewAllText>{ele?.ctaText} ›</ViewAllText>
                    </AnchorCoverTag>
                  </div>
                </ViewAllRow>
              </>
            ) : (
              <>
                <ProductContainer
                  data={ele}
                  isForJoyfulPage={isForJoyfulPage}
                  showNewProductVideoCardUx={showNewProductVideoCardUx}
                  setChangeCartCount={setChangeCartCount}
                />
                <div className="viewAllButton">
                  <AnchorCoverTag
                    url={ele?.webUrl}
                    cardEffect={cardEffect?.index === 0 ? 'lowOpacity' : ''}
                    callbackFunction={() =>
                      callbackFunction(
                        0,
                        categoryData?.items?.[selectedCategory]?.webUrl,
                      )
                    }
                  >
                    <p>View all</p>
                  </AnchorCoverTag>
                </div>
              </>
            )}
          </CategoryGridContainer>
        );
      })}
    </BestsellerContainer>
  );
}

export default CategoryProductFilter;
